import {
  EMPTY_LIST,
  EMPTY_OBJECT,
  EMPTY_STRING,
} from '../../../constants/common'
import { CurrencySelect } from '../CurrencySelect'

import { MoneyInputControlContent } from './MoneyInputControlContent'

/**
 * A borderless German-format money input (`10.000,00`) without the currency
 * selector. Emits the canonical raw amount string (`10000.00`, '' when empty).
 */
function MoneyInput({
  controlProps = EMPTY_OBJECT,
  value,
  onChange,
  ...restProps
}) {
  function handleChange({ amount }) {
    onChange(amount)
  }

  return (
    <CurrencySelect
      {...restProps}
      controlProps={{
        ...controlProps,
        Content: MoneyInputControlContent,
      }}
      currencyOptions={EMPTY_LIST}
      value={{ amount: value ?? EMPTY_STRING }}
      onChange={handleChange}
    />
  )
}

export default MoneyInput
